module.exports = __webpack_public_path__ + "img/comm-new-banner.fb6f4b0f.jpg";